import '../style/nav.sass'

import { Link, NavLink } from 'react-router-dom'
import { FaBars } from 'react-icons/fa';
import { useEffect, useState } from 'react';
// old // import { GiDeliveryDrone, GiPaintBrush } from 'react-icons/gi'
// old // import { FaAngleRight, FaHome, FaGlasses, FaQuestionCircle, FaLaptopCode, FaPhoneAlt } from 'react-icons/fa'

// let logo = require("../assets/vgb.png"); 
let logo = require("../assets/hand.png");

export default function Nav() {
    const [isOpen, setIsOpen] = useState(false) 

    return (
        <>
            {/* <Link to='/' className="logo">
                <img src={logo} alt="Ichor Amoc, logo" />
            </Link> */}
            <div className="mediaNav">
                <button onClick={() => setIsOpen(!isOpen)} className='mediaMenu'>
                    <FaBars className='mediaIcon' />
                </button>
            </div>
            <div onClick={() => setIsOpen(!isOpen)} className={isOpen ? "darkenbg" : ""}></div>
            <header className={isOpen ? "headerMenu" : ''}>
                <nav>
                    <ul>
                        <NavLink activeClassName="active" to='/' exact>  <li> Home </li></NavLink>
                        <NavLink activeClassName="active" to='/drone'>   <li> Drone </li></NavLink>
                        <NavLink activeClassName="active" to='/art'>     <li> Art </li></NavLink>
                        {/* <NavLink activeClassName="active" to='/projects'><li> Projects </li></NavLink> */}
                        {/* <NavLink activeClassName="active" to='/about'>   <li> About</li></NavLink> */}
                    </ul>
                </nav>
            </header>
        </>
    )
}